import styled from 'styled-components'

import { CTABannerLayoutValues } from '../constants'
import { CTABannerItem as CTABannerItemProps } from '../types'
import { DefaultLayout } from './components/DefaultLayout'
import { InlineLayout } from './components/InlineLayout'
import { Match } from 'features/Shared/components'

/**
 * This component is the representation of the CTA Banner Item in contentful.
 * This is just a presentational component that renders the banner.
 *
 * It is not meant to be used by itself, so you better use:
 * - The CTA Banner src/features/CTABanner/CTABanner.tsx
 * which act as container for this component.
 *
 * If by any reason you still want to use it, please import it as it is and not
 * modify this component. If you have to add something, or conditionally render
 * another stuff, please create you own component for so.
 *
 * */
export const CTABannerItem = (props: CTABannerItemProps) => {
  const {
    layout,
    backgroundGradient: { startColor, endColor },
    ...defaultLayoutProps
  } = props

  const { text: _, ...inlineLayoutProps } = defaultLayoutProps
  return (
    <StyledContainer $startColor={startColor} $endColor={endColor}>
      <Match condition={layout}>
        <Match.Case when={CTABannerLayoutValues.default}>
          <DefaultLayout {...defaultLayoutProps} />
        </Match.Case>
        <Match.Case when={CTABannerLayoutValues.inline}>
          <InlineLayout {...inlineLayoutProps} />
        </Match.Case>
        <Match.Default>
          <DefaultLayout {...defaultLayoutProps} />
        </Match.Default>
      </Match>
    </StyledContainer>
  )
}

const StyledContainer = styled.div<{ $startColor: string; $endColor: string }>`
  width: 100%;
  background: linear-gradient(
    90deg,
    ${({ $startColor }) => $startColor} 24.28%,
    ${({ $endColor }) => $endColor} 88.09%
  );
`
